import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ContextProvider } from './Context';
import Home from './pages/Home';
import Profile from './pages/user/servers/Profile';
import ServerStats from './pages/user/servers/ServerStats';
import { TermsOfService } from './pages/TermsOfService';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import NotFound from './pages/404';
import './App.css';

export default function App() {
  return (
    <ContextProvider>
      <div className="App">
        <BrowserRouter >
          <Routes>
            <Route index element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/user/profile" element={<Profile />} />
            <Route path="/user/servers/:serverId" element={<ServerStats />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ContextProvider>
  );
}


